var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00195 5.75098V5.00098C7.00195 3.89641 7.89738 3.00098 9.00195 3.00098H11.002C12.1065 3.00098 13.002 3.89641 13.002 5.00098V5.75098H15.502C15.9162 5.75098 16.252 6.08676 16.252 6.50098C16.252 6.91519 15.9162 7.25098 15.502 7.25098H15.002V15.001C15.002 16.1055 14.1065 17.001 13.002 17.001H7.00195C5.89738 17.001 5.00195 16.1055 5.00195 15.001V7.25098H4.50195C4.08774 7.25098 3.75195 6.91519 3.75195 6.50098C3.75195 6.08676 4.08774 5.75098 4.50195 5.75098H7.00195ZM8.50195 5.50098H11.502V5.00098C11.502 4.72483 11.2781 4.50098 11.002 4.50098H9.00195C8.72581 4.50098 8.50195 4.72483 8.50195 5.00098V5.50098ZM6.50195 7.25098H13.502V15.001C13.502 15.2771 13.2781 15.501 13.002 15.501H7.00195C6.72581 15.501 6.50195 15.2771 6.50195 15.001V7.25098Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.20a9cbb161c862e6013406a803abeb15.svg";
export { ForwardRef as ReactComponent };